import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  text: {
    marginTop: '5vh',
    marginRight: '10%',
    marginLeft: '10%',
  },
  title: {
    marginBottom: theme.spacing(4),
  },
  subtitle: {
    color: theme.palette.primary.main,
    fontSize: 24,
    fontWeight: 700,
  },
  header: {
    marginTop: theme.spacing(4),
  },
  headerButtonContainer: {
    display: 'flex',
  },
  headerButton: {
    margin: theme.spacing(1),
    minWidth: '50px',
  },
  formContainer: {
    marginTop: theme.spacing(2),
  },
  formSubtitle: {
    fontSize: 18,
    fontStyle: 'italic',
    fontWeight: 300,
    marginTop: theme.spacing(4),
  },
}));
